import "./CalendarView.html";
import "./CalendarView.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import CalendarViewComponentController from "./CalendarViewComponentController";

export default class CalendarViewComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            extraClasses: "@",
            initialDate: "<",
            readonly: "<",
            schedule: "<",
            timeZone: "<",
        };
        this.controller = CalendarViewComponentController;
        this.templateUrl = "/App/Components/Forms/ResultSchedule/CalendarView/CalendarView.html";
    }
}

module("mmManagePortal").component("irCalendarView", new CalendarViewComponent());
